// extracted by mini-css-extract-plugin
export var addressFields = "_n4-0";
export var animationContainer = "_n4-1";
export var footer = "_n4-2";
export var lineItems = "_n4-3";
export var modalContent = "_n4-4";
export var orderName = "_n4-5";
export var strong = "_n4-6";
export var warning = "_n4-7";